import React from 'react';
import PropTypes from 'prop-types';
import { get as _get} from 'lodash';

import Chip from '@ui/Chip';
import { getCompetitorsNameFromEvent } from '@utils/competitorName';
import {renderDescription} from '@utils/tableHelpers';

import {
    checkIfIsTvStreaming,
    getCompetitorWarnings,
    getTvStreamingEncoderId,
} from '../../utils/eventSchedule';

export const CompetitorNameAndDescription = ({event = {}}) => {
    const competitorWarning = getCompetitorWarnings(event),
        isTvStreaming = checkIfIsTvStreaming(event),
        tvStreamingEncoderId = getTvStreamingEncoderId(event),
        tvStreamingInfoExist = isTvStreaming && null !== tvStreamingEncoderId,
        competitorsWarningsExist = 0 !== competitorWarning.length,
        marginClass = (event.description && (competitorsWarningsExist || tvStreamingInfoExist))
            ? 'marginBetweenDescriptionAndWarnings'
            : '';

    return (
        <>
            <div>{getCompetitorsNameFromEvent(event)}</div>
            <div>{renderDescription(event.description, event.color, event.external_description)}</div>
            <div className={marginClass}>
                {tvStreamingInfoExist && <Chip size='small' label='TV Streaming' />}
            </div>
        </>
    );
};

CompetitorNameAndDescription.propTypes = {
    event: PropTypes.object.isRequired,
};

export const MatchId = ({event = {}}) => {
    const matchId = _get(event, 'sr_event.match.id', false);

    return (
        <div>
            {(matchId) || '-'}
        </div>
    );
};

MatchId.propTypes = {
    event: PropTypes.object.isRequired,
};
